import type { DocumentSummary } from "@/types/api";

export const API_BASE = import.meta.env.VITE_API_BASE ?? "";

/** Resolve a Worker-relative path (e.g. "/api/docs/:id/file") against the API base. */
export function apiUrl(pathOrUrl: string): string {
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  return `${API_BASE}${pathOrUrl}`;
}

async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    credentials: "include",
    headers: {
      ...(init?.body && !(init.body instanceof FormData) ? { "Content-Type": "application/json" } : {}),
      ...init?.headers,
    },
  });
  if (!res.ok) {
    let message = `${res.status} ${res.statusText}`;
    try {
      const body = (await res.json()) as { error?: string };
      if (body.error) message = body.error;
    } catch {
      /* ignore */
    }
    throw new Error(message);
  }
  return (await res.json()) as T;
}

export const api = {
  health: () => apiFetch<{ ok: boolean }>("/health"),
  me: () => apiFetch<{ email: string }>("/api/me"),

  uploadDocument: async (file: File): Promise<{ documentId: string }> => {
    const fd = new FormData();
    fd.append("file", file);
    return apiFetch("/api/upload", { method: "POST", body: fd });
  },

  listDocuments: () => apiFetch<{ documents: DocumentSummary[] }>("/api/docs"),
  getDocument: (id: string) => apiFetch<DocumentSummary>(`/api/docs/${id}`),
  deleteDocument: (id: string) =>
    apiFetch<{ ok: true }>(`/api/docs/${id}`, { method: "DELETE" }),

  // /api/chat is streaming — handled by lib/streaming.ts, not here.
};
